


import { injectFetch } from '../../interface/util';
import { IAuthManager, IAuthManagerArguments, IAuthManagerStatus } from './auth.if';
import auth from '../api/auth';

interface IAuthManagerPrv extends IAuthManager {
    pendingRenew: Promise<string>|null;
}

function manager(authArguments: IAuthManagerArguments | string): IAuthManager {
    const args: IAuthManagerArguments =
        ((authArguments as IAuthManagerArguments)?.apiUrl != undefined) ?
        authArguments as IAuthManagerArguments :
        JSON.parse(authArguments as string) as IAuthManagerArguments;

    /* make sure onCreation #hasExpired() returns true */
    const expirySetDate = new Date();
    expirySetDate.setSeconds(expirySetDate.getSeconds()-4);

    const manager: IAuthManagerPrv = {
        pendingRenew: null,

        accessToken: '',
        expiry: expirySetDate,

        apiUrl: args.apiUrl,
        apiExtension: args.apiExtension,
        clientId: args.clientId,
        clientSecret: args.clientSecret,
        grantType: args.grantType,
        username: args.username,
        password: args.password,

        status: function(this: IAuthManagerPrv): IAuthManagerStatus {
            if ( this.accessToken.length <= 1 ) { return "Unset"; }

            if ( this.hasExpired() ) { return "Expired"; }

            return "Authorized";
        },

        hasExpired: function(this: IAuthManagerPrv): boolean {
            const now = (new Date()).getTime();
            const threshold = now - 30; /* if we are within 30s, get a new token */
            const expiry = this.expiry.getTime();
            const hasExpired = expiry < threshold;
            return hasExpired;
        },

        renew: function(this: IAuthManagerPrv): Promise<string> {
            const manager = this;

            if ( !manager.hasExpired() ) {
                return Promise.resolve(manager.accessToken);
            }

            if ( !manager.pendingRenew ) {
                manager.pendingRenew = new Promise(async function(resolve, reject) {
                    const fetcher = await injectFetch();
                    auth(
                        fetcher,
                        manager.apiUrl, 
                        manager.apiExtension,
                        {
                            clientId: manager.clientId, 
                            clientSecret: manager.clientSecret, 
                            grantType: manager.grantType, 
                            username: manager.username, 
                            password: manager.password,
        
                        })
                        .then(function(authResponse) {
                            manager.accessToken = authResponse.access_token;
                            const expiry = new Date();
                            expiry.setSeconds(expiry.getSeconds() + authResponse.expires_in);
                            manager.expiry = expiry;
                            resolve(authResponse.access_token);
                            manager.pendingRenew = null;
                        })
                        .catch(error => reject(`Authentication failed: ${JSON.stringify(error).substring(0, 30)}`));
                });
            }

            return manager.pendingRenew;
        },

        serialize: function(this: IAuthManagerPrv): string {
            return JSON.stringify(this);
        }
    };

    return manager as IAuthManager;
}

export default manager;